import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/contactus.scss";
import { STORE_CONFIG } from "../config/store";

function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const handleInputChange = ({ target: { name, value } }) => {
    setFormData((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (!formData.name.trim()) nextErrors.name = "Name is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) nextErrors.email = "Enter a valid email";
    if (formData.message.trim().length < 10) nextErrors.message = "Please include at least 10 characters";
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;
    const subject = encodeURIComponent(`Website enquiry from ${formData.name}`);
    const body = encodeURIComponent(`Reply to: ${formData.email}\n\n${formData.message}`);
    window.location.href = `mailto:${STORE_CONFIG.supportEmail}?subject=${subject}&body=${body}`;
  };
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="contact-page">
      <div className="breadcrumb"><Link to="/" onClick={toTop}>Home</Link> &gt; <span>Contact</span></div>
      <div className="contact-container">
        <div className="contact-info">
          <h1>Contact</h1>
          <div className="info-block">
            <p><strong>{STORE_CONFIG.brand}</strong></p>
            <p>Operating region: {STORE_CONFIG.operatingRegion}</p>
            <p><a href={`mailto:${STORE_CONFIG.supportEmail}`}>{STORE_CONFIG.supportEmail}</a></p>
          </div>
          <div className="info-block hours-block">
            <h3>BEFORE YOU WRITE</h3>
            <p>Include your order number when asking about an existing order. Do not email card or bank details.</p>
            <p>Opening this form uses your own email application; the website does not silently submit or store the message.</p>
          </div>
        </div>
        <div className="contact-form-container">
          <form onSubmit={handleSubmit} className="contact-form" noValidate>
            <div className="form-group"><label htmlFor="name">Name</label><input id="name" name="name" value={formData.name} onChange={handleInputChange} className={errors.name ? "error" : ""} />{errors.name && <span className="error-text">{errors.name}</span>}</div>
            <div className="form-group"><label htmlFor="email">Email</label><input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} className={errors.email ? "error" : ""} />{errors.email && <span className="error-text">{errors.email}</span>}</div>
            <div className="form-group"><label htmlFor="message">Message</label><textarea id="message" name="message" value={formData.message} onChange={handleInputChange} className={errors.message ? "error" : ""} rows="8" />{errors.message && <span className="error-text">{errors.message}</span>}</div>
            <button type="submit" className="submit-btn">Open email</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
